const typhoonBusTimelineData = [
  {
    mon_guan: '06:30',
    mon_kfs: '',
    aft_guan: '06:30',
    aft_kfs: '',
  },
  {
    mon_guan: '07:00',
    mon_kfs: '',
    aft_guan: '07:00',
    aft_kfs: '',
  },
  {
    mon_guan: '07:30',
    mon_kfs: '',
    aft_guan: '07:30',
    aft_kfs: '',
  },
  {
    mon_guan: '08:00',
    mon_kfs: '',
    aft_guan: '08:00',
    aft_kfs: '',
  },
  {
    mon_guan: '',
    mon_kfs: '18:30',
    aft_guan: '',
    aft_kfs: '12:35',
  },
  {
    mon_guan: '',
    mon_kfs: '19:00',
    aft_guan: '',
    aft_kfs: '13:00',
  },
  {
    mon_guan: '',
    mon_kfs: '19:30',
    aft_guan: '',
    aft_kfs: '13:30',
  },
  {
    mon_guan: '',
    mon_kfs: '20:00',
    aft_guan: '',
    aft_kfs: '14:00',
  },
  {
    mon_guan: '',
    mon_kfs: '20:30',
    aft_guan: '',
    aft_kfs: '',
  },
];

export { typhoonBusTimelineData };


// WEBPACK FOOTER //
// ./src/stores/typhoonBusTimelineData.js